import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {DataSharingService} from '../iBoxx/services/data-sharing.service';
import {LoaderService} from '../iBoxx/shared/loader/loader-service.services';
import {ApiService} from '../iBoxx/services/api.service';
import {Router} from '@angular/router';
import {UtilService} from '../iBoxx/services/UtilService';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DownloadLinkModalComponent} from '../download-link-modal/download-link-modal.component';

export class RulesBenchmark{
  region = '';
  families: string[] = [];
  documents = [];
}

@Component({
  selector: 'app-indices-docs-page',
  templateUrl: './indices-docs-page.component.html',
  styleUrls: ['./indices-docs-page.component.scss']
})
export class IndicesDocsPageComponent implements OnInit, DoCheck {

  @Input() indexType = 'all';
  tabList = [''];
  documents: string[] = [];
  rulesBenchmark: RulesBenchmark[] = [];
  currentRegion = '';
  pageName = '';
  category = 'Holiday Calendars';
  searchInput = '';
  searched = false;
  searchResult: string[] = [];
  timeout: any = null;

  docStatus: boolean = false;

  constructor(private shareService: DataSharingService, private loader: LoaderService,
              private route: Router, private apiService: ApiService, private utilService: UtilService, private modalService: NgbModal) {
    this.apiService.getDocStatus().subscribe((resp: any) => {
      this.docStatus = resp;
    });
  }

  ngOnInit(): void {
    this.shareService.indexURL.subscribe((resp: any) => {
      if (resp && resp.includes('doc')) {
        this.pageName = resp.split('=')[1];
        this.category = this.pageName === 'iBoxx' ? 'Holiday Calendars' : this.pageName === 'EMIX' ? 'General Methodology Documents' : 'Documentation';
        this.getTabListFor();
        this.getObjectsFromS3();
      }
    });
  }

  ngDoCheck(): void {
    if (this.documents.length === 0) {
      this.getObjectsFromS3();
    }
  }

  getTabListFor(): void {
    switch (this.pageName) {
      case 'iBoxx':
        // @ts-ignore
        const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
          {
            all: [],
            futures: [],
            trs: [],
            esg: [],
          };
        this.tabList = tabGroup[this.indexType].length > 0 ? tabGroup[this.indexType]
          : this.indexType === 'trs' ? ['screener', 'trs calculator', 'documentation']
            : ['screener', 'documentation'];
        break;
      case 'Carbon':
        // @ts-ignore
        this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) ? JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) :
          ['home', 'documentation'];
        break;
      case 'EMIX':
        // @ts-ignore
        this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForEMIX')) ? JSON.parse(window.sessionStorage.getItem('tabListForEMIX')) :
          ['screener', 'documentation'];
        break;
    }
  }

  getObjectsFromS3(): void {
    let filterCondition = 'Documentation/' + this.pageName + '/';
    if (this.pageName === 'iBoxx'){
      switch (this.category) {
        case 'Methodology':
          filterCondition += 'Methodology/';
          break;
        case 'Holiday Calendars':
          filterCondition += 'Holiday_Calendars/';
          break;
        case 'Rules Benchmark':
          filterCondition += 'Rules_Benchmark/';
          break;
        case 'Rules Liquid':
          filterCondition += 'Rules Liquid/';
          break;
        case 'Tradable - Standardized TRS':
          filterCondition += 'Standardized TRS/';
          break;
        case 'Tradable - Futures':
          filterCondition += 'Futures/';
          break;
        case 'ESG/Sustainable':
          filterCondition = 'ESG_Sustainable/';
          break;
      }
    }
    if (this.pageName === 'EMIX'){
      switch (this.category) {
        case 'General Methodology Documents':
          filterCondition += 'Methodology/General Methodology Documents/';
          break;
        case 'Methodologies':
          filterCondition += 'Methodology/Methodologies/';
          break;
        case 'List of EMIX Indices':
          filterCondition += 'Methodology/List of EMIX Indices/';
          break;
      }
    }
    if (window.location.href.includes('local_')){
      this.getDataFromMock(filterCondition);
    }else{
      if (filterCondition === 'ESG_Sustainable/'){
        this.documents = this.shareService.s3Contents
          .filter((content: any) => content.familyName === 'iBoxx ESG/Sustainable')
          .map((content: any) => content.documentName);
      }else {
        this.getDataFromS3(filterCondition);
      }
    }
    if (this.category === 'Rules Benchmark'){
      this.populateRulesBenchmark('/Rules_Benchmark/');
    }
    if (this.category === 'Rules Liquid'){
      this.populateRulesBenchmark('/Rules Liquid/');
    }
  }

  getDisplayName(docName: string): string{
    return docName.split('/')[docName.split('/').length - 1];
  }

  populateRulesBenchmark(filterCondition: string): void{
    this.rulesBenchmark = [];
    const benchmarkString = 'Documentation/iBoxx' + filterCondition;
    const benchmarkDocs = this.documents.map((value: string) => value.replace(benchmarkString, ''));
    const uniqueRegions = [...new Set(benchmarkDocs.map((docName: string) => docName.split('/')[0]))];
    this.currentRegion = uniqueRegions[0];
    uniqueRegions.forEach((region: string) => {
      const rulesBenchmark: RulesBenchmark = new RulesBenchmark();
      rulesBenchmark.region = region;
      const uniqueFamilies = [...new Set(benchmarkDocs.filter((doc: string) => (doc.split('/')[0] === region))
        .map((docName: string) => docName.split('/')[1])
      )];
      rulesBenchmark.families = uniqueFamilies.slice(uniqueFamilies.indexOf('') + 1);
      rulesBenchmark.families.forEach((family: string) => {
        const document: any = {};
        document.label = family;
        document.options = [];
        const docs = this.documents.filter((doc: string) => doc.includes(benchmarkString + region + '/' + family + '/'));
        docs.slice(docs.find((doc: string) => doc === (benchmarkString + region + '/' + family + '/')) === undefined ? 0 : 1)
          .forEach((doc: string) => {
            document.options.push({
              label: doc.split('/')[doc.split('/').length - 1],
              value: doc,
              selected: false
            });
          });
        // @ts-ignore
        rulesBenchmark.documents.push(document);
      });
      this.rulesBenchmark.push(rulesBenchmark);
    });
  }

  getDocumentListFor(family: string, benchmark: any): any{
    this.deselectOtherDocuments();
    return benchmark.find((item: any) => item.label === family);
  }

  deselectOtherDocuments(): void{
    this.rulesBenchmark.forEach((benchmark: any) => {
      benchmark.documents.forEach((document: any) => {
        document.options.map((option: any) => option.selected = false);
      });
    });
  }

  openDocument(documentName: string): void{
    const URL = this.apiService.createGetPath('/search/fileFromBucket',
      ['fileName',
    // @ts-ignore
        encodeURIComponent(this.shareService.s3Contents.find((content: any) => content.documentName === documentName).documentName)]);
    window.open(URL);
    const modalRef = this.modalService.open(DownloadLinkModalComponent, {size: 'xl'});
    const documentInfo = {};
    // @ts-ignore
    documentInfo[documentName] = URL;
    modalRef.componentInstance.documentInfo = documentInfo;
  }

  openDrillDownPage(identifier: string): void{
    switch (this.pageName) {
      case 'iBoxx':
        const index = this.shareService.headlineIndices.find((data: any) => {
          if (data.indexName === identifier.split('?')[0] && data.inflationAdjustment === identifier.split('?')[1]) {
            return data;
          }
        });
        this.route.navigateByUrl('iBoxx/details/index?id=' + index.id);
        break;
      case 'Carbon':
        this.route.navigateByUrl('Carbon/details/index?id=' + identifier.split(' : ')[0]);
        break;
      case 'EMIX':
        const emixIndex = this.shareService.EMIXIndices.indexLevels
          .find((level: any) => identifier === (level.indexName + ' (' + level.currency + ')'));
        this.route.navigateByUrl('EMIX/details/index?id=' + emixIndex.id);
        break;
    }
  }

  openTab(event: any): void {
    switch (event) {
      case 'screener':
        switch (this.indexType) {
          case 'all':
            this.route.navigateByUrl('iBoxx/Screener');
            break;
          case 'futures':
            this.route.navigateByUrl('iBoxx/Futures/Screener');
            break;
          case 'trs':
            this.route.navigateByUrl('iBoxx/TRS/Screener');
            break;
          case 'esg':
            this.route.navigateByUrl('iBoxx/ESG/Screener');
            break;
          case 'emix':
            this.route.navigateByUrl('EMIX/Screener');
            break;
        }
        break;
      case 'home':
        this.route.navigateByUrl('Carbon/Home');
        break;
      case 'trs calculator':
        this.route.navigateByUrl('iBoxx/TRS/Calculator');
        break;
      case 'documentation':
        break;
      default:
        this.openDrillDownPage(event);
        break;
    }
  }

  getDataFromS3(filterCondition: string): void{
    this.documents = this.shareService.s3Contents
      .filter((content: any) => !content.documentName.endsWith('/'))
      .map((content: any) => content.documentName)
      .filter((doc: string) => doc.includes(filterCondition))
      .sort((str1: string, str2: string) => {
        if (this.category === 'Holiday Calendars'){
          return str1 > str2 ? -1 : 1;
        }
        return str1 < str2 ? -1 : 1;
      });
    // if (this.documents.indexOf(filterCondition) > -1) {
    //   this.documents.splice(this.documents.indexOf(filterCondition), 1);
    // }
  }

  getDataFromMock(filterCondition: string): void{
    this.documents = Object.keys(this.utilService.mockData)
      .filter((doc: string) => doc.includes(filterCondition))
      .slice(filterCondition.includes('Liquid') ? 0 : 1)
      .sort((str1: string, str2: string) => {
        if (this.category === 'Holiday Calendars'){
          return str1 > str2 ? -1 : 1;
        }
        return str1 < str2 ? -1 : 1;
      });
  }
  searchTerm(event: any): void {
    clearTimeout(this.timeout);
    this.searchResult = [];
    this.searched = false;
    this.timeout = setTimeout(() => {
      if (event.key !== 'Enter') {
        if (this.searchInput.trim().length > 0) {
          this.runSearch();
        } else {
          this.searched = false;
        }
      }
    }, 1000);
  }

  runSearch(): void{
    this.searched = true;
    this.searchResult = this.shareService.s3Contents
      .filter((content: any) => !content.documentName.endsWith('/'))
      .map((content: any) => content.documentName)
      .filter((docName: string) => docName.toLowerCase().includes(this.searchInput.toLowerCase()) && !docName.toLowerCase().includes('headline'))
      .sort((doc1: string, doc2: string) => doc1 < doc2 ? -1 : 1);
  }
}
